import { useT } from "../LangContext";
import { C } from "../../lib/colors";
import StrategyLab from "./StrategyLab";

// ─── Fase 15-16 · Bloque 1 — LabTab ──────────────────────────────────────
// The Strategy Lab promoted to its own primary tab. Renders the analysis
// in a 2-col card grid (4 KPI cards + 1 wide compat card) for breathing room.
export default function LabTab({ strategy, onAnalyzed, setActiveTab }) {
  const { t } = useT();

  const hasData = strategy.mode === "bootstrap"
                  && Array.isArray(strategy.bootstrapData)
                  && strategy.bootstrapData.length >= 30
                  && strategy.bootstrapStats;

  return (
    <div className="pf-tab-body fg-fadein" data-testid="pane-lab">
      <div className="pf-tab-head">
        <div className="pf-tab-watermark">03</div>
        <div className="pf-tab-kicker">03 · lab</div>
        <h2 className="pf-tab-title">{t("tab_lab_title")}</h2>
        <div className="pf-tab-hint">{t("lab_tab_purpose")}</div>
      </div>

      {!hasData ? (
        <div data-testid="lab-empty-state" className="fg-panel"
             style={{ padding: 28, marginTop: 14, textAlign: "center",
                       fontFamily: "var(--plex)" }}>
          <div style={{ color: C.smoke, fontSize: 14, lineHeight: 1.6, marginBottom: 18,
                         fontStyle: "italic" }}>
            {t("lab_empty_title")}
          </div>
          <button data-testid="lab-empty-cta"
                  onClick={() => setActiveTab("strategy")}
                  style={{ background: "transparent", border: `1px solid ${C.brass}`,
                           color: C.brass, padding: "8px 18px", cursor: "pointer",
                           fontFamily: "var(--mono)", fontSize: 12, letterSpacing: 0.2 }}>
            {t("lab_empty_cta")}
          </button>
        </div>
      ) : (
        <StrategyLab strategy={strategy} onAnalyzed={onAnalyzed} />
      )}
    </div>
  );
}
